import React, { Fragment, useEffect, useState } from 'react';
// import numeral from 'numeral';

import { useTranslation } from 'react-i18next/hooks';

// import Backdrop from '../../../Backdrop/Backdrop';
// import GroupTalkTextFileKuraPreview from './GroupTalkTextFileKuraPreview';
import GroupKuraFileIcon from './GroupKuraFileIcon';
// import Img from "react-cool-img";
// import SmallModal from '../../../Modal/SmallModal';
// import Loader from '../../../Loader/Loader';

import { useStore } from '../../../../hook-store/store';
// import { 
//   getOriginalFileNameFromKey,
// } from '../../../../util/bucket/bucket-object-util';
import { 
  getKuraBucketFileSignedUrl,
} from '../../../../util/group/kura-bucket-file';

// import { isImageFile, isVideoFile, isAudioFile } from '../../../util/image';
// import { SOCKET_GROUP_URL } from '../../../App';
import { SOCKET_GROUP_URL } from '../../../../App';

import { marks } from '../../../../images/marks';
import classes from './GroupTalkTextFileKura.module.css';
// import './VideoTextTalk.css'




const GroupTalkTextFileKura = (props) => {
  // console.log('VideoTextTalkTextFile.js props', props);
  const {
    inputData,
    isVisibleFileEl,
    kuraFileIconRef,
  } = props;
  
  const [t] = useTranslation('translation');

  const [store, dispatch] = useStore();
  const { 
    selectedKuraFileData,
    isGroupMember,
    userGetGroupKuraFileDataList,
   } = store.groupStore;

  const [showSepImage, setShowSepImage] = useState(false);
  const [isDownLoading, setIsDownLoading] = useState(false);
  const [fileUrl, setFileUrl] = useState('');
  const [errorMessage, setErrorMessage] = useState('');

  useEffect(() => {
    // console.log(inputData)
    if (isGroupMember && !isDownLoading && isVisibleFileEl && inputData.kuraFileInfo && inputData.groupRoomId
        && inputData.kuraFileInfo.mimeType 
        && inputData.kuraFileInfo.mimeType.split('/')[0] === 'image'
    ) {

      getAddKuraFileDataHandler(
        inputData.kuraFileInfo,
        inputData.groupRoomId,
        // userGetGroupKuraFileDataList,
      )
    }
  },[isVisibleFileEl, inputData]);

  useEffect(() => {
    const lsList = localStorage.getItem('lsUserGetGroupKuraFileDataList');

    if (lsList) {
      const currentList = JSON.parse(lsList);
      // console.log('currentList in useEffect', currentList)
      dispatch('SET_USERGETGROUPKURAFILEDATALIST', currentList);
    }

  },[localStorage.getItem('lsUserGetGroupKuraFileDataList')]);

  const setShowSepImageHandler = (value) => {
    if (!isGroupMember) {
      return;
    }

    setShowSepImage(value);

    if (value) {
      getKuraFileSignedUrlHandler(
        inputData.kuraFileInfo,
        inputData.groupRoomId,
      );
    } else {
      setFileUrl('');
    }
  };


  const getKuraFileSignedUrlHandler = async (
    kuraFileInfo,
    groupRoomId,
  ) => {
    let currentList = [];

    try {

      //// reuse selectedKuraFileData signedUrl for preview
      if (selectedKuraFileData && selectedKuraFileData.signedUrl &&
        selectedKuraFileData.bucket === kuraFileInfo.bucket &&
        selectedKuraFileData.key === kuraFileInfo.key
      ) {
        setFileUrl(selectedKuraFileData.signedUrl);
        return;
      }

      setIsDownLoading(true);
      setErrorMessage('');

      const resData = await getKuraBucketFileSignedUrl(
        SOCKET_GROUP_URL,
        localStorage.getItem('token'),
        kuraFileInfo.bucket,
        kuraFileInfo.key,
        kuraFileInfo.initialKey,
        groupRoomId,
      );

      if (resData?.data.url) {
        const url = resData.data.url; 
        setFileUrl(url);


        if (selectedKuraFileData?.bucket === kuraFileInfo.bucket &&
          selectedKuraFileData.key === kuraFileInfo.key
        ) {
          dispatch('SET_SELECTEDKURAFILEDATA', {
            ...selectedKuraFileData,
            signedUrl: url,
          });
          
        } else {
            dispatch('SET_SELECTEDKURAFILEDATA', {
              ...kuraFileInfo,
              signedUrl: url,
            });
        }

        const lsList = localStorage.getItem('lsUserGetGroupKuraFileDataList');

        if (lsList) {
          currentList = JSON.parse(lsList);
        }

        addKuraFileDataHandler(
          kuraFileInfo,
          groupRoomId,
          {
            ...resData.data,
            isNotFoundError: false,
          },
          currentList,
        );

      }

      setIsDownLoading(false);

    } catch(err) {
      console.log(err);
      setIsDownLoading(false);
      setErrorMessage('Get file failed.');

      if (err.message === 'bucket-object-not-found') {
        setErrorMessage('Get file failed. File not found. File might be deleted.');

        const lsList = localStorage.getItem('lsUserGetGroupKuraFileDataList');

        if (lsList) {
          currentList = JSON.parse(lsList);
        }

        addKuraFileDataHandler(
          kuraFileInfo,
          groupRoomId,
          { isNotFoundError: true },
          currentList,
        )      
      }
      throw err;
    }
  };

  const getAddKuraFileDataHandler = async(
    kuraFileInfo,
    groupRoomId,
    // userGetGroupKuraFileDataList,
  ) => {
    let currentList = [];

    try {
      // console.log(kuraFileInfo, groupRoomId, userGetGroupKuraFileDataList)
      if (!kuraFileInfo || !kuraFileInfo.key || !groupRoomId) {
        return;
      }

      // let isFileData = false;

      const userGetFileData = findFileDataFromUserGetList(
        groupRoomId,
        kuraFileInfo,
        userGetGroupKuraFileDataList,
      );

      // console.log('userGetFileData', userGetFileData);

      const roomFileData = userGetFileData.roomFileData;
      const fileData = userGetFileData.fileData;

      if (roomFileData && fileData) {
        // isFileData = true;
        if (fileData.getTime > Date.now() - 1000*60*60*24) {
          return;
        }
      }


      setIsDownLoading(true);

      const resData = await getKuraBucketFileSignedUrl(
        SOCKET_GROUP_URL,
        localStorage.getItem('token'),
        kuraFileInfo.bucket,
        kuraFileInfo.key,
        kuraFileInfo.initialKey,
        groupRoomId,
      );


      const lsList = localStorage.getItem('lsUserGetGroupKuraFileDataList');

      if (lsList) {
        currentList = JSON.parse(lsList);
      }
      //   const use
      // currentList = userGetGroupKuraFileDataList;
      // console.log('currentList', currentList)

      if (resData.data) {
        addKuraFileDataHandler(
          kuraFileInfo,
          groupRoomId,
          {
            ...resData.data,
            isNotFoundError: false,
          },
          currentList,
          // userGetGroupKuraFileDataList,
        )
      }

      setIsDownLoading(false);

    } catch(err) {
      console.log(err);

      const lsList = localStorage.getItem('lsUserGetGroupKuraFileDataList');

      if (lsList) {
        currentList = JSON.parse(lsList);
      }
      // console.log('currentList in catch', currentList)
      
      if (err.message === 'bucket-object-not-found') {
        addKuraFileDataHandler(
          kuraFileInfo,
          groupRoomId,
          { isNotFoundError: true },
          currentList,
        )

        setIsDownLoading(false);
      }
      throw err;
    }
  }

  const addKuraFileDataHandler = async (
    kuraFileInfo, 
    groupRoomId, 
    fileSignedUrlData,
    userGetGroupKuraFileDataList,
    // roomFileData,
    // fileData,
  ) => {
    try {

      const userGetFileData = findFileDataFromUserGetList(
        groupRoomId,
        kuraFileInfo,
        userGetGroupKuraFileDataList,
      );

      console.log('userGetFileData', userGetFileData);

      const roomFileData = userGetFileData.roomFileData;
      const fileData = userGetFileData.fileData;

      if (fileSignedUrlData) {
        const nowTime = Date.now();

        const addFileData = {
          ...fileSignedUrlData,
          kuraFileInfo: kuraFileInfo,
          getTime: nowTime,
        };

        if (!roomFileData) {
          const newRoomFileData = {
            groupRoomId: groupRoomId,
            lastGetTime: nowTime,
            files: [addFileData],
          }

          const newFilesDataList = userGetGroupKuraFileDataList.concat(newRoomFileData);
          // dispatch('SET_USERGETGROUPKURAFILEDATALIST', newFilesDataList);
          localStorage.setItem(
            'lsUserGetGroupKuraFileDataList' , 
            JSON.stringify(newFilesDataList)
          );

        } else {
          if (roomFileData.files.length > 0) {
            let updatedList = [];

            if (!fileData) {
              updatedList = roomFileData.files.concat([addFileData]);
            
            } else {
              updatedList = roomFileData.files.map(ele => {
                if (ele.kuraFileInfo.bucket === kuraFileInfo.bucket && 
                      ele.kuraFileInfo.key === kuraFileInfo.key
                ) {
                  return addFileData;
                } else {
                  return ele;
                }
              });
            }

            const updatedRoomFileData = {
              groupRoomId: groupRoomId,
              lastGetTime: nowTime,
              files: updatedList,
            };

            const newGetFileList = userGetGroupKuraFileDataList.map(ele => {
              if (ele.groupRoomId === groupRoomId) {
                return updatedRoomFileData;
              } else {
                return ele;
              }
            });

            // dispatch('SET_USERGETGROUPKURAFILEDATALIST', newGetFileList);
            localStorage.setItem(
              'lsUserGetGroupKuraFileDataList' , 
              JSON.stringify(newGetFileList)
            );

          }
        }
      }


    } catch(err) {
      console.log(err);
      throw err;
    }
  };


  const findFileDataFromUserGetList = (
    groupRoomId, 
    kuraFileInfo,
    userGetGroupKuraFileDataList,
  ) => {
    let fileData;  
    
    const roomFileData = userGetGroupKuraFileDataList.find(element => {
          return element.groupRoomId === groupRoomId;
        });
      
    if (roomFileData) {
      const fileList = roomFileData.files;

      if (fileList && fileList.length > 0) {
        fileData = fileList.find(ele => {
          // console.log(ele)
          return ele.kuraFileInfo.bucket === kuraFileInfo.bucket && 
            ele.kuraFileInfo.key === kuraFileInfo.key;
        });

      }
    }

    return {
      roomFileData: roomFileData,
      fileData: fileData,
    }
  };




  return (
    <Fragment>
      <GroupKuraFileIcon 
        inputData={inputData}
        // isVisibleFileEl,
        showSepImage={showSepImage}
        setShowSepImage={setShowSepImage}
        isDownLoading={isDownLoading}
        setShowSepImageHandler={setShowSepImageHandler}
        fileUrl={fileUrl}
        errorMessage={errorMessage}
        kuraFileIconRef={kuraFileIconRef}
      />
    </Fragment>
  );
};

export default GroupTalkTextFileKura;